import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TOpenName =
    'menu'
    | 'user-info'
    | 'notification'
    | 'filters'
    | 'chart'
    | 'campaing-type'
    | 'cluster'
    | 'goods-add'
    | 'faq-modal'
    | 'empty-goods-add'
    | 'refill-balance'
    | 'confirmation-start'
    | 'confirmation-bet-overfill'
    | 'instruction-modal'
    | 'offsetting-modal';

interface IState {
    open?: TOpenName
}

const initialState: IState = {
    open: undefined
};

export const sliderMenu = createSlice({
    initialState,
    name    : 'slider-menu',
    reducers: {
        reset: () => initialState,
        set  : (state, action: PayloadAction<Partial<IState>>) => {
            if(state.open === action.payload.open) {
                return initialState;
            }

            return {
                ...state,
                ...action.payload
            };
        }
    }
});

export default sliderMenu.reducer;
